var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { InputLabel, FormControl, InputAdornment, Tooltip, OutlinedInput, Box, Typography, Alert } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { colors } from '../../Themes/colors';
var TextField = React.forwardRef(function (props, ref) {
    var _a;
    var _b = React.useState(false), pwdTypeToggle = _b[0], setPwdTypeToggle = _b[1];
    var _c = React.useState(props === null || props === void 0 ? void 0 : props.value), val = _c[0], setVal = _c[1];
    var handleChange = function (e) {
        var value = e.target.value;
        if (props === null || props === void 0 ? void 0 : props.IsAmount) {
            value = value.replace(/[^0-9.]/g, '');
            if ((value.startsWith('0') || value.startsWith('.')) && !props.IsZeroAllowble) {
                value = value.replace(/^0+|^\./, '');
            }
            if (props.IsZeroAllowble && value.startsWith('0')) {
                value = value.startsWith('0') ? '0' : '';
            }
            var parts = value.split('.');
            var integerPart = parts[0];
            var decimalPart = parts[1];
            if (decimalPart !== undefined) {
                decimalPart = decimalPart.slice(0, 2);
            }
            value = decimalPart !== undefined ? "".concat(integerPart, ".").concat(decimalPart) : integerPart;
            var formattedValue = value !== '' ? "$".concat(value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')) : '';
            value = formattedValue;
            setVal(formattedValue);
        }
        else {
            if (props.testRegExp) {
                value = props.testRegExp.test(value) ? value : value.slice(0, -1);
            }
            else if (props.regExp) {
                value = value === null || value === void 0 ? void 0 : value.replace(props.regExp, '');
            }
        }
        props.onChange(__assign(__assign({}, e), { target: __assign(__assign({}, e.target), { name: props.name, value: value }) }));
    };
    return (React.createElement(FormControl, { fullWidth: props.fullWidth, error: props.error, variant: "standard", className: props.disabled ? 'disable-fields outlined-text-field' : 'outlined-text-field' },
        React.createElement(InputLabel, { required: props.required, shrink: true, htmlFor: props.id, sx: { fontWeight: (_a = props.fontWeight) !== null && _a !== void 0 ? _a : 'normal' } },
            props.label ? props.label.charAt(0) + props.label.slice(1) : '',
            props.isMandatoryField &&
                React.createElement(Box, { component: 'span', color: "red" }, "*"),
            props.tooltip &&
                React.createElement(Tooltip, { title: props.tooltip },
                    React.createElement(InfoOutlinedIcon, null))),
        React.createElement(OutlinedInput, __assign({ inputRef: ref, name: props.name, id: props.id, size: 'small', onChange: handleChange, sx: __assign(__assign({}, (props.multiline && { height: 'auto' })), { '&.Mui-disabled': {
                    color: '#000',
                    backgroundColor: colors.greyShades[17],
                    '& .MuiOutlinedInput-input': {
                        color: '#000',
                        WebkitTextFillColor: '#000',
                    },
                } }), onPaste: props.onPaste, value: (props === null || props === void 0 ? void 0 : props.IsAmount) && val ? val : props === null || props === void 0 ? void 0 : props.value, multiline: props.multiline, rows: props.rows, maxRows: props.maxRows, minRows: props.minRows, disabled: props.disabled, onKeyDown: props.onKeyDown, onBlur: props.onBlur, placeholder: props.placeholder, inputProps: { maxLength: props.maxLength ? props.maxLength : 50 }, fullWidth: props.fullWidth, className: props.className || '' }, (props.startAdornment && {
            startAdornment: React.createElement(InputAdornment, { position: "start", className: 'startAdornment-input' },
                React.createElement(Typography, { variant: 'body1', sx: {
                        '.Mui-disabled &': {
                            color: '#000',
                        },
                    } }, props.startAdornment)),
        }), (props.endAdornment && {
            endAdornment: React.createElement(InputAdornment, { position: "start" }, props.endAdornment),
        }), ((props.inputType === "password") && {
            endAdornment: (React.createElement(InputAdornment, { position: "end", onClick: function () { setPwdTypeToggle(!pwdTypeToggle); } }, pwdTypeToggle ? React.createElement(VisibilityOffOutlinedIcon, null) : React.createElement(VisibilityOutlinedIcon, null))),
            type: pwdTypeToggle ? 'text' : 'password'
        }), (props.maskValue && {
            type: 'password'
        }))),
        props.error_message && (React.createElement(Box, { sx: { mt: 1 } },
            React.createElement(Alert, { severity: "error", icon: React.createElement(ErrorOutlineIcon, { sx: { fontSize: 20 } }), sx: {
                    backgroundColor: '#fee2e2',
                    borderLeft: '4px solid #dc2626',
                    color: '#991b1b',
                    fontWeight: 500,
                    fontSize: '13px',
                    padding: '8px 12px',
                    '& .MuiAlert-icon': {
                        color: '#dc2626',
                    }
                } }, props.error_message)))));
});
export default React.memo(TextField);
